import React from 'react'

const Body = () => {
    return (
        <body className="body">
            <img src="https://assets-api.kathmandupost.com/thumb.php?src=https://assets-cdn.kathmandupost.com/uploads/source/news/2018/miscellaneous/Tol-Khamcha-04022018063028.jpeg&w=900&height=601" alt="" />
            <div className="details">
                <h4>Respected British Laure:</h4>
                <h5>Tol Khamcha Magar</h5>
            </div>
        </body>
    )
}

export default Body
